<template>
  <div v-if="teadsFallback" id="adform-outstream" style="height: 0; overflow: hidden">
    <component
      :is="'script'"
      v-bind="adConfig"
      language="javascript"
      src="//s1.adform.net/banners/scripts/video/outstream/inview.js"
      data-skip-button-label="Kapat"
      data-visible-threshold="1:0.5"
      data-sound-onhover="true"
      async
    ></component>
  </div>
</template>
<script>
import { defineComponent, onBeforeUnmount, onMounted, ref } from '@nuxtjs/composition-api';
import { useDebug } from '@/composables/useDebug';

export default defineComponent({
  setup() {
    const { oLog, debugQueries } = useDebug('Outstream');
    const { outstreamTest } = debugQueries;
    const teadsFallback = ref(false);

    const adConfig = {};
    if (outstreamTest) {
      oLog('Outstream test started');
      adConfig['data-vast-id'] = 11136859;
    } else {
      adConfig['data-pmp-id'] = 243933;
    }
    onMounted(() => {
      window.initializeAdformOutstream = function () {
        oLog('Teads Fallback Initialize Adform Outstream Called');
        teadsFallback.value = true;
      };
    });
    onBeforeUnmount(() => {
      window.initializeAdformOutstream = null;
    });
    return { teadsFallback, adConfig };
  },
});
</script>
<style lang="scss">
.adform-adbox {
  z-index: 2 !important;
}
</style>
